import { Box, Typography } from '@mui/material'
import { CommunityOutlinedIcon } from '../../components/icons'

export const CommunityPage = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        py: 10,
        px: 3,
        mx: 'auto',
        mt: 4,
        borderRadius: 4,
        bgcolor: 'primary.dark',
        color: 'primary.contrastText',
        textAlign: 'center',
      }}
    >
      <CommunityOutlinedIcon sx={{ fontSize: '3rem', color: 'primary.contrastText' }} />
      <Typography variant="h4" fontWeight={700}>
        Community
      </Typography>
      <Typography variant="body1" sx={{ opacity: 0.7, maxWidth: 420 }}>
        Coming soon — connect with your neighbors and stay informed about local water quality together.
      </Typography>
    </Box>
  )
}